let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5oQdF")).then(() => parcelRequire('2YfJN'));